// Photo slot - renders a real grayscale image when a src is provided,
// otherwise a deliberate dark placeholder (never a generic icon).
import { IMAGES } from "./images";

export default function Photo({ slug, label, className = "", eager = false }) {
  const src = IMAGES[slug];
  if (src) {
    return (
      <img
        src={src}
        alt={label || slug}
        loading={eager ? "eager" : "lazy"}
        className={`photo-img ${className}`}
      />
    );
  }
  return <div className={`photo-ph ${className}`} data-slug={slug} aria-hidden="true" />;
}
